export const facebook = {
  APP_ID: "",
};

export const google = {
  API_KEY: "",
  CLIENT_ID:
    "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
  SECRET: "",
};

// export const API_URL = "http://52.23.223.231";
// export const API_URL = "http://localhost:4000";
export const API_URL = "https://mrmto-api.myappinfo.in";
// export const API_URL = "https://api.unitythink.com"; // Replace with your actual API URL

export default {
  facebook,
  google,
  API_URL,
};
